(function() {
    'use strict';

    function workflowDocumentsController($scope, $state, milestones,
        workflowStateService, milestoneModalService, zipbuilderDataService, notifyService) {
        var vm = this;

        vm.workflowData = workflowStateService.get();
        vm.workflowId = vm.workflowData.Id.split('/')[1];
        vm.phaseDocuments = [];
        vm.zipDownloadBlobReference = null;
        vm.showZipDownload = false;

        milestoneModalService.getMilestonesAndTemplates(milestones).then(function (milestonesAndTemplates) {
            if (milestonesAndTemplates.length > 0) {
                milestoneModalService.openModal(milestonesAndTemplates);
            }
        });

        function buildPhaseDocs() {
            var phaseDocs = vm.workflowData.Phases.reduce(function (current, phase) {
                var parts = phase.InformationParts.filter(function(prefilteredPart) {
                    return prefilteredPart.$type === 'Ecap.Api.ViewModels.DocumentViewModel, Ecap.Api' &&
                        !prefilteredPart.IsRemoved &&
                        prefilteredPart.BlobSummaries.some(function(blob) { return !blob.IsRemoved; });
                });

                parts.forEach(function(part) {
                    var blobs = part.BlobSummaries.filter(function(allBlob) { return !allBlob.IsRemoved; });

                    blobs.forEach(function(blob) {
                        current.push({
                            Access: blob.Access,
                            Phase: phase.Title,
                            Title: part.Title,
                            Path: part.Path,
                            FileName: blob.FileName,
                            BlobReference: blob.BlobReference,
                            DateUploaded: blob.DateUploaded,
                            UploadedByUserName: blob.UploadedByUserName
                        });
                    });
                });

                return current;
            },[]);

            vm.documents = phaseDocs.filter(function(doc) {
                return doc.Access.View;
            }).sort(function(doc) {
                return doc.DateUploaded;
            }).reverse();
        }

        buildPhaseDocs();

        function updateZipDownloadButton(data) {
            vm.showZipDownload = vm.documents.filter(function (blob) {
                return blob.Access.View && !blob.IsRemoved;
            }).length > 1;

            if (data) {
                vm.zipDownloadBlobReference = data;
                notifyService.notify('A zip file was created for all of the project documents' +
                     ' - <a style="text-decoration:underline;font-weight:bold;" href="' +
                    '/files/getupload?blobreference=' + vm.zipDownloadBlobReference +
                    '&fileName=AllProjectDocuments.zip">Download Zip File</a>');
            }
            else {
                vm.zipDownloadBlobReference = null;
            }
        }

        vm.buildZipFile = function() {
            var data = {
                Blobs: vm.documents.filter(function (blob) {
                    return blob.Access.View && !blob.IsRemoved;
                }).map(function (filteredBlob) {
                    return {
                        FileName: filteredBlob.FileName,
                        BlobReference: filteredBlob.BlobReference
                    };
                })
            };
            vm.buildingZipFile = true;
            zipbuilderDataService.build(data).then(function (data) {
                vm.buildingZipFile = false;
                updateZipDownloadButton(data);
            }).catch(function (err) {
                vm.buildingZipFile = false;
            });
        }

        updateZipDownloadButton();

        $scope.$on('workflowUpdated', function () {
            vm.workflowData = workflowStateService.get();
            buildPhaseDocs();
        });
    }

    workflowDocumentsController.$inject = ['$scope', '$state', 'milestones',
        'workflowStateService', 'milestoneModalService', 'zipbuilderDataService', 'notifyService'];

    angular.module('ecap.workflow').controller('workflowDocumentsController', workflowDocumentsController);
})();
